/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, FormControlLabel, Button, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import { tableAPI } from '../../services/apiService';
import './TableForm.css';

function convertToEnglishNumbers(str) {
    if (!str) return str;
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    let result = str;
    for (let i = 0; i < 10; i += 1) {
        result = result.replace(new RegExp(persianNumbers[i], 'g'), i);
    }
    return result;
}

function TableForm() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [form, setForm] = useState({
        table_id: '',
        seats_number: '',
        free: true,
    });

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]:
                name === 'seats_number'
                    ? convertToEnglishNumbers(value.replace(/[^\d۰-۹]/g, ''))
                    : value,
        }));
    };

    const handleSwitchChange = (e) => {
        setForm({ ...form, free: e.target.checked });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.table_id || !form.seats_number) {
            setSnackbar({
                open: true,
                message: t('all_fields_required'),
                severity: 'warning',
            });
            return;
        }

        try {
            const seatsNumber = Number(convertToEnglishNumbers(form.seats_number));

            await tableAPI.create({
                table_id: form.table_id,
                seats_number: seatsNumber,
                free: form.free,
            });

            navigate('/tables', {
                state: { successMessage: t('table_add_success') },
            });
        } catch (err) {
            setSnackbar({
                open: true,
                message: t('table_add_error'),
                severity: 'error',
            });
        }
    };

    const handleCloseSnackbar = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return (
        <div className="add_table_page">
            <Sidebar />
            <div className="add_table_main">
                <Navbar />
                <div className="form_wrapper">
                    <h2>{t('add_table')}</h2>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="table_id">
                            {t('table_number')}
                            <input
                                id="table_id"
                                name="table_id"
                                type="text"
                                placeholder={t('enter_table_number')}
                                value={form.table_id}
                                onChange={handleChange}
                                required
                            />
                        </label>
                        <label htmlFor="seats_number">
                            {t('seats_number')}
                            <input
                                id="seats_number"
                                name="seats_number"
                                type="text"
                                placeholder={t('enter_seats_number')}
                                value={form.seats_number}
                                onChange={handleChange}
                                required
                            />
                        </label>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.free}
                                    onChange={handleSwitchChange}
                                    color="primary"
                                />
                            }
                            label={form.free ? t('table_free') : t('table_busy')}
                        />

                        <button type="submit" className="submit_btn">
                            {t('submit_table')}
                        </button>
                    </form>
                </div>
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default TableForm;
